import { Component, Input, OnInit, NgModule } from '@angular/core';
import { Auth0Service } from 'src/app/auth/auth0.service';
import { UserService } from 'src/app/shared/services/user/user.service';
import {
  DxListModule,
  DxContextMenuModule,
  DxPopupModule,
  DxFormModule,
  DxValidationGroupModule,
  DxValidatorModule,
  DxButtonModule,
} from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { PipeModule } from 'src/app/pipe.module';
import { UserPicturePreviewModule } from 'src/app/shared/components/user-picture-preview/user-picture-preview.module';

@Component({
  selector: 'app-user-panel',
  templateUrl: 'user-panel.component.html',
  styleUrls: ['./user-panel.component.scss'],
})
export class UserPanelComponent implements OnInit {
  @Input() menuItems: any;
  @Input() menuMode: string;
  firstName = '';
  lastName = '';
  profile: any;

  constructor(
    public auth0: Auth0Service,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.getMe();
    this.auth0.userProfile$.subscribe(res => (this.profile = res));
  }

  getMe() {
    this.userService.getMe().subscribe(
      result => this.setName(result),
      () => this.auth0.logout(),
    );
  }

  private setName(result: any) {
    this.firstName = result.data?.first_name;
    this.lastName = result.data?.last_name;
  }
}

@NgModule({
  imports: [
    DxListModule,
    DxContextMenuModule,
    CommonModule,
    PipeModule,
    UserPicturePreviewModule,
    DxPopupModule,
    DxFormModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxButtonModule,
  ],
  declarations: [UserPanelComponent],
  exports: [UserPanelComponent],
})
export class UserPanelModule {}
